import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { getArticles, getEventsAction } from '@/store/common/actions';
import { setEvents } from '@/store/common/mutations';
import { State, Images } from './types';
import { Dictionary } from '@/types';

const GET_ARTICLE = 'getArticle';
const GET_ARTICLES = 'getArticles';
const GET_EVENTS = 'getEvents';
const INIT = 'init';
const SET_ARTICLES = 'setArticles';
const SET_STATE = 'setState';
const DEFAULT_IMAGES = {
  littleThumb: '',
  middleThumb: '',
};

const createStoreModule = (providers: any) => {
  const { $api, $captureError } = providers;

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageBlogArticleStore extends VuexModule implements State {
    // State
    seo_title = '';
    seo_description = '';
    seo_keywords = '';
    name = '';
    section_id = '';
    sub_section_id = '';
    articles: State['articles'] = [];
    images: State['images'] = DEFAULT_IMAGES;
    videos: State['videos'] = [];
    recommended: State['recommended'] = [];

    // Mutations
    @Mutation
    [SET_STATE](payload: State) {
      const images = {
        ...DEFAULT_IMAGES,
        ...(payload.images || {}),
      };
      Object.assign(this, { ...payload, images });
    }

    @Mutation
    [SET_ARTICLES](payload: Array<any>) {
      this.articles = payload;
    }

    @Mutation
    setEvents(payload: Array<any>) {
      return setEvents(this, payload, 'recommended');
    }

    // Actions
    @Action
    [INIT](params: any) {
      const { dispatch } = this.context;
      return Promise.all([
        dispatch(GET_ARTICLE, params),
        dispatch(GET_ARTICLES),
        // dispatch(GET_EVENTS, params),
      ]);
    }

    @Action({ commit: SET_STATE })
    async [GET_ARTICLE]({ id, code }: any) {
      const params = { id, url_code: code };
      let result: Dictionary<any> = {};
      try {
        const {
          data: { data },
        } = await $api.get('blog/get', { params });
        result = data;
      } catch (e) {
        $captureError(e);
      } finally {
        return result;
      }
    }

    @Action({ commit: SET_ARTICLES })
    async [GET_ARTICLES]() {
      const articles = await getArticles($api);
      return articles;
    }

    @Action
    [GET_EVENTS]({ id }: any) {
      const config = { id, url: 'events/recommended' };
      return getEventsAction(this.context.commit, config, $api);
    }
  }

  return PageBlogArticleStore;
};

export { INIT };
export default createStoreModule;



// WEBPACK FOOTER //
// ./src/pages/blog/article/store.ts